module.exports = __webpack_public_path__ + "images/manual-0270921032769dabf230b86afea53d07.png";